import React, { useContext } from 'react';
import classNames from 'classnames';

import { SettingsContext } from './context';
import { useHistory } from 'react-router-dom';
import { Routes } from 'routes';
import useFeatureFlags, { FeatureFlagTypes } from 'common/hooks/useFeatureFlags';
import { useHackReRenderForFeatureFlags } from 'common/hooks/useHackReRenderForFeatureFlags';
import { useP2PInviteSettings } from '../coordinator-dashboard/p2p-invite-settings/P2PInviteSettings';

const isActiveMenuItem = (menuItem: string, activeMenuItem: string) => menuItem === activeMenuItem;

const computeClassNames = (activeMenuItem: string) => {
    const menuItems = [
        'personal-information',
        'security',
        'payment-options',
        'notifications',
        'invite-friends-family',
    ];

    return menuItems.reduce((acc: { [key: string]: string }, menuItem) => {
        acc[menuItem] = classNames(
            'font-semibold text-xs text-brand underline cursor-pointer mb-5',
            isActiveMenuItem(menuItem, activeMenuItem)
                ? 'no-underline text-brand-dark cursor-default'
                : undefined
        );

        return acc;
    }, {});
};

const SidebarMenu = () => {
    const { activeMenuItem } = useContext(SettingsContext);
    const history = useHistory();
    const classes = computeClassNames(activeMenuItem);
    const { isEnabled, loadingFlags } = useFeatureFlags();
    const { isP2PInviteEnabled } = useP2PInviteSettings();

    return (
        <ul className="flex flex-row flex-wrap justify-between gap-3  border-b border-r-0 border-l-0 border-t-0 border-grey-5 sm:flex-col">
            <li className={classes['personal-information']}>
                <button
                    onClick={() => history.push(Routes.ShopAccountSettingsPersonalInformationTab)}
                >
                    Personal Information
                </button>
            </li>

            <li className={classes.security}>
                <button onClick={() => history.push(Routes.ShopAccountSettingsSecurityTab)}>
                    Security
                </button>
            </li>

            <li className={`settings_payment_options ${classes['payment-options']}`}>
                <button onClick={() => history.push(Routes.ShopAccountSettingsPaymentOptionsTab)}>
                    Payment Options
                </button>
            </li>

            {isP2PInviteEnabled ? (
                <li className={classes['invite-friends-family']}>
                    <button
                        onClick={() =>
                            history.push(Routes.ShopAccountSettingsInviteFriendsFamilyOptionsTab)
                        }
                    >
                        Invite Friends & Family
                    </button>
                </li>
            ) : null}

            {!loadingFlags && isEnabled(FeatureFlagTypes.enable_iterable) ? (
                <li className={`settings_payment_options ${classes['notifications']}`}>
                    <button
                        onClick={() => history.push(Routes.ShopAccountSettingsNotificationsTab)}
                    >
                        Notifications
                    </button>
                </li>
            ) : null}
        </ul>
    );
};

export const HeaderAndMenu = () => {
    const key = useHackReRenderForFeatureFlags();

    return (
        <div className="settings_nav_menu flex flex-col w-full md:w-48">
            <p className="text-brand-dark text-3xl mb-5 font-light sm:font-normal">Settings</p>

            <SidebarMenu key={key} />
        </div>
    );
};
